import React, { useState } from 'react';
import { DropDownBox } from '@apply/components';
import { Panel, PanelTheme } from '@apply/components';

export const DropDownBoxDemo: React.FC = () => {
    // State for each example
    const [value, set_value] = useState('');
    const [advancedValue, set_advancedValue] = useState('');
    // Example dropdown items
    const dropdownItems = ['Option 1', 'Option 2', 'Option 3'];
    const dropdownItemsAdvancedDataBinding = [
        {
            id: 1,
            name: 'Property 1',
            price: 330,
        },
        {
            id: 2,
            name: 'Property 2',
            price: 400,
        },
        {
            id: 3,
            name: 'Property 3',
            price: 2400,
        },
    ];

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>DropDownBox</li>
            <br />
            <Panel theme={PanelTheme.White}>
                <div style={{ padding: '1rem' }}>
                    {/* Example 1: Dropdown Box*/}
                    <div style={{ marginBottom: '1rem' }}>
                        <DropDownBox
                            id='dropdownboxDemo'
                            value={value}
                            onChange={set_value}
                            label='DropDownBox'
                            helperText='Helper Text: Click the arrow to view options'
                            required={true}
                            dataSource={dropdownItems}
                            placeholder='Select a demo item...'
                        />
                    </div>
                    {/* Example 2: Dropdown Box Read Only*/}
                    <div style={{ marginBottom: '1rem' }}>
                        <DropDownBox
                            id='dropdownboxDemo'
                            value={value}
                            onChange={set_value}
                            label='DropDownBox (Read Only)'
                            helperText='Helper Text: Click the arrow to view options'
                            required={true}
                            dataSource={dropdownItems}
                            placeholder='Select a demo item...'
                            readOnly={true}
                        />
                    </div>
                    {/* Example 2: Dropdown Box Advanced Binding*/}
                    <div style={{ marginBottom: '1rem' }}>
                        <DropDownBox
                            id='dropdownboxDemo'
                            value={advancedValue}
                            onChange={set_advancedValue}
                            label='DropDownBox (Advanced Data Binding)'
                            helperText='Helper Text: Click the arrow to view options'
                            required={true}
                            dataSource={dropdownItemsAdvancedDataBinding}
                            valueExpr='id'
                            displayExpr='name'
                            placeholder='Select an advanced demo item...'
                        />
                    </div>
                </div>
            </Panel>
        </div>
    );
};
